import React, { useContext, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { reactLocalStorage } from "reactjs-localstorage";
import DropDownMenu, { Dropdown, Menu } from "../components/common/sidebarMenu";
// import { DropDown, Menu } from '../components/common/sidebarMenu';
import { UserContext } from "../context/theme";
import { BEAM_URL } from "../services/api-url";
import authAxios from "../services/authAxios";
import common from "../services/common";
import axios from "axios";

function Header() {
    const { auth, setAuth, setUserInfo, setMiniSidebar } = useContext(UserContext);
    const Logout = () => {
        localStorage.removeItem("token");
        setAuth(false);
    };

    const getProfile = async () => {
        const token = reactLocalStorage.get("token") || localStorage.getItem("token");
        if (!token) return;
        try {
            const res = await axios.get(`${BEAM_URL}/auth/profile`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const user = res?.data?.user || {};
            setUserInfo({ ...user, _id: user.id });
        } catch (error) {
            common.error(error);
        }
    };

    function refreshtoken() {
        authAxios({
            method: "GET",
            url: `/refreshToken`,
        })
            .then((res) => {
                reactLocalStorage.set("token", res?.data?.data?.token);
            })
            .catch((error) => {
                // reactLocalStorage.remove("token");
            });
    }
    useEffect(() => {
        let intrVal;
        if (auth) {
            intrVal = setInterval(() => {
                refreshtoken();
            }, 10000);
        }
        if (auth) {
            // getStoreCounts();
            getProfile();
        }
        return () => clearInterval(intrVal);
    }, [auth]);

    return (
        <>
            <div className="left-sidebar-wrapper">
                <nav className="sidebar">
                    <button type="button" className="cs-menu-close" aria-label="Close menu" onClick={() => setMiniSidebar("")}>
                        <span className="icon-x"></span>
                    </button>
                    <div className="sidebar-header text-center">
                        <NavLink activeclassname="isActive" to="/dashboard">
                            <img src="/assets/images/nyc.png" alt="NYC Buildings" className="cs-brand-logo" />
                        </NavLink>
                        <strong>
                            <NavLink activeclassname="isActive" to="/dashboard">
                                <img src="/assets/images/nyc.png" alt="NYC Buildings" className="cs-brand-logo cs-brand-logo-sm" />
                            </NavLink>
                        </strong>
                    </div>

                    <div className="left-nav-menu" onClick={() => setMiniSidebar("")}>
                        <DropDownMenu>
                            <Menu path="/dashboard" title="Dashboard" icon="icon-wrap icon-home" />
                            <Menu path="/products" title="Buildings" icon="fa fa-table" />
                            <Menu path="/tickets" title="Tickets" icon="icon-wrap icon-ticket" />
                            <Menu path="/users/add" title="Add User" icon="icon-wrap icon-user-plus" />
                            {/* <Menu path="/change-password" title="Change Password" icon="fa fa-key" /> */}
                        </DropDownMenu>
                    </div>
                    <div className="cs-sidebar-sky" aria-hidden="true">
                        <svg viewBox="0 0 260 120" preserveAspectRatio="xMidYMax meet" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#0a2113">
                                <rect x="0" y="70" width="26" height="50" />
                                <rect x="28" y="52" width="22" height="68" />
                                <rect x="52" y="82" width="20" height="38" />
                                <rect x="74" y="60" width="24" height="60" />
                                <rect x="100" y="40" width="22" height="80" />
                                <rect x="124" y="74" width="20" height="46" />
                                <rect x="146" y="58" width="24" height="62" />
                                <rect x="172" y="46" width="22" height="74" />
                                <rect x="196" y="78" width="20" height="42" />
                                <rect x="218" y="62" width="22" height="58" />
                                <rect x="242" y="72" width="18" height="48" />
                            </g>
                            <g fill="#8CC63F">
                                <rect className="cs-tw" x="34" y="60" width="3" height="4" opacity="0.85" />
                                <rect x="41" y="70" width="3" height="4" opacity="0.5" />
                                <rect className="cs-tw" x="106" y="50" width="3" height="4" opacity="0.85" style={{ animationDelay: "1.1s" }} />
                                <rect x="113" y="62" width="3" height="4" opacity="0.5" />
                                <rect x="80" y="72" width="3" height="4" opacity="0.5" />
                                <rect className="cs-tw" x="152" y="70" width="3" height="4" opacity="0.85" style={{ animationDelay: "0.6s" }} />
                                <rect x="178" y="58" width="3" height="4" opacity="0.5" />
                                <rect className="cs-tw" x="185" y="68" width="3" height="4" opacity="0.85" style={{ animationDelay: "1.8s" }} />
                                <rect x="224" y="74" width="3" height="4" opacity="0.5" />
                                <rect className="cs-tw" x="231" y="82" width="3" height="4" opacity="0.85" style={{ animationDelay: "0.9s" }} />
                            </g>
                        </svg>
                    </div>
                    <div className="version text-center">
                        <span className="vs-mobile">{common.version()}</span>
                    </div>
                </nav>
            </div>
        </>
    );
}
export default Header;
